import { ScreenReadersContent } from '@hivebrite/design-system/ScreenReadersContent';

const AboutScreenReader = ({ name }) => (
  <ScreenReadersContent>
    {' '}
    {s__('about %{name}').i__({ name })}{' '}
  </ScreenReadersContent>
);

export default AboutScreenReader;
